<div class="wip-validation-error-modal-container">
  <div class="wip-validation-error-modal-container__error">
    {{ 'input_app_common.error' | translate }}
  </div>
  <div class="wip-validation-error-modal-container__content">
    <div *ngIf="errorTxt && sizeAndCountList.length; else defaultTxt">
      <div class="error-text">
        {{ errorTxt | translate }}
      </div>
      <ion-row>
        <ion-col size="4" *ngFor="let item of sizeAndCountList">
          <span> {{ item.name }} :</span>
          <span> {{ item.count }}</span>
        </ion-col>
      </ion-row>
    </div>
    <ng-template #defaultTxt>
      {{ 'input_app_common.defaultErrorMessage' | translate }}
    </ng-template>
  </div>
  <div class="wip-validation-error-modal-container__btn-container">
    <ui-custom-button [btnTxt]="'input_app_common.okay' | translate" (clickEvent)="dismissModal()"></ui-custom-button>
  </div>
</div>
